//imgs
import img01 from "../../assets/images/chapters/06/01.jpg";
import img02 from "../../assets/images/chapters/06/02.jpg";
import img03 from "../../assets/images/chapters/06/03.jpg";
import img04 from "../../assets/images/chapters/06/04.jpg";
import img05 from "../../assets/images/chapters/06/05.jpg";

import img06 from "../../assets/images/chapters/06/06.jpg";
import img07 from "../../assets/images/chapters/06/07.jpg";
import img08 from "../../assets/images/chapters/06/08.jpg";

import img09 from "../../assets/images/chapters/06/09.jpg";
import img10 from "../../assets/images/chapters/06/10.jpg";
import img11 from "../../assets/images/chapters/06/11.jpg";

import img12 from "../../assets/images/chapters/06/12.jpg";
import img13 from "../../assets/images/chapters/06/13.jpg";
import img14 from "../../assets/images/chapters/06/14.jpg";

import img15 from "../../assets/images/chapters/06/15.jpg";
import img16 from "../../assets/images/chapters/06/16.jpg";
import img17 from "../../assets/images/chapters/06/17.jpg";

import img18 from "../../assets/images/chapters/06/18.jpg";

import { captions, moonImgs } from "../../assets/data/chapters/chapter06";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter06">
      <div className="group01">
        <div className="location">
          <ScrollReveal>SPACECRAFT</ScrollReveal>
          <ScrollReveal>
            <span className="arrow"></span>
            <span>INTERIOR</span>
          </ScrollReveal>
        </div>
        <ScrollReveal className="picture">
          <img src={img01} />
          <p className="caption">{captions[0]}</p>
        </ScrollReveal>
      </div>

      <div className="group02">
        <div className="row">
          <ScrollReveal>
            <img src={img02} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img03} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <div className="column">
            <ScrollReveal>
              <img src={img04} />
            </ScrollReveal>
            <ScrollReveal>
              <img src={img05} />
              <p className="caption">{captions[0]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group03">
        <div className="row">
          <ScrollReveal>
            <img src={img06} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img07} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <div className="column">
            <ScrollReveal>
              <img src={img08} />
              <p className="caption">{captions[0]}</p>
            </ScrollReveal>
          </div>
          <ScrollReveal className="location">
            CREW ⁂ IN{"\n"}
            SPACECRAFT
          </ScrollReveal>
        </div>
      </div>

      <div className="group04">
        <div className="row">
          <ScrollReveal>
            <img src={img09} />
            <p className="caption">{captions[1]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img10} />
            <p className="caption">{captions[2]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img11} />
            <p className="caption">{captions[3]}</p>
          </ScrollReveal>
        </div>
      </div>

      <ScrollReveal className="separator">
        <span>Horrocks &</span>
        <span>—hipparchus</span>
      </ScrollReveal>

      <div className="group05">
        <div className="row">
          <ScrollReveal>
            <img src={img12} />
            <p className="caption">{captions[4]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img13} />
            <p className="caption">{captions[5]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img14} />
            <p className="caption">{captions[6]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group06">
        <div className="row">
          <ScrollReveal>
            <img src={img15} />
          </ScrollReveal>
          <ScrollReveal>
            <img src={img16} />
            <p className="caption">{captions[7]}</p>
          </ScrollReveal>
          <ScrollReveal>
            <img src={img17} />
            <p className="caption">{captions[8]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group07">
        {moonImgs.map((img, i) => (
          <ScrollReveal className="picture" key={i}>
            <img src={img} />
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal className="group08">
        <div className="title">
          view of the moon{"\n"}
          half in darkness
        </div>
        <div className="picture">
          <img src={img18} />
        </div>
      </ScrollReveal>
    </div>
  );
};

export default Chapter;
